import { gql } from "@apollo/client";

export const EMAIL_TEMPLATES = gql`
    query emailTemplates {
        emailTemplates {
            id
            replyTo
            subject
            daysBeforeReservation
            body
            emailType
        }
    }
`;

export const EMAIL_TEMPLATE_BY_ID = gql`
    query emailTemplateById($id: Int!, $type: EmailType!) {
        emailTemplateById(id: $id, type: $type) {
            id
            replyTo
            subject
            daysBeforeReservation
            body
            emailType
        }
    }
`;

export const UPSERT_EMAIL_TEMPLATE = gql`
    mutation upsertEmailTemplate($input: EmailTemplateInput!) {
        upsertEmailTemplate(input: $input) {
            id
            replyTo
            subject
            daysBeforeReservation
            body
            emailType
        }
    }
`;

export const DELETE_EMAIL_TEMPLATE = gql`
    mutation deleteEmailTemplate($id: ID!) {
        deleteEmailTemplate(id: $id)
    }
`;
